import React from 'react';

const App: React.FC = () => (
  <div style={{ fontFamily: 'Inter, sans-serif', padding: '2rem' }}>
    <h1>Luminafactory</h1>
    <p>Platform scaffold — ready for development.</p>
  </div>
);

export default App;
